import React, { useState, useEffect, Fragment } from 'react';
import axios from 'axios';
import classNames from 'classnames/bind';

import { withErrorBoundary } from 'containers/ErrorBoundary';

import { currentLanguage } from 'utils/currentLanguage';

import Container from 'components/Container';
import Wysiwyg from 'components/Wysiwyg';
import Loader from 'components/Loader';

import styles from './ServicesList.module.scss';
const cx = classNames.bind(styles);

const ServicesList = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get('/' + currentLanguage + '/rest/views/osfy?_format=json')
      .then(({ status, data }) => {
        setData(status === 200 ? data : []);
      })
      .catch(() => {
        setData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <Fragment>
      {!!data.columns && !!data.columns.length ? (
        <section>
          <h2 className={cx('section-title')}>{data.title}</h2>
          <div className={cx('root')}>
            <Container>
              <div className={cx('listing')}>
                {data.columns.map((item, index) => {
                  return (
                    <a
                      href={item.link}
                      key={index}
                      className={cx('item')}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className={cx('img')}>
                        <img src={item.image} alt={item.title} />
                      </div>
                      <h3 className={cx('item-title')}>
                        <span className={cx('title-text')}>{item.title}</span>
                      </h3>
                      <Wysiwyg
                        className={cx('description')}
                        text={item.description}
                      />
                    </a>
                  );
                })}
              </div>
            </Container>
          </div>
        </section>
      ) : null}
    </Fragment>
  );
};

export default withErrorBoundary(ServicesList);



// WEBPACK FOOTER //
// ./src/components/ServicesList/ServicesList.js